import {
  INVENTORY_TRANSFER_RESET_STATE,
  INVENTORY_TRANSFER_PAGE_REQUEST,
  INVENTORY_TRANSFER_SET_TRANSFERS,
  INVENTORY_TRANSFER_SET_TRANSFER_DETAIL,
  INVENTORY_TRANSFER_SET_OUTLETS,
  INVENTORY_TRANSFER_SET_ALL_OUTLETS,
  INVENTORY_TRANSFER_SET_SELECTED_OUTLET_FROM_NAME,
  INVENTORY_TRANSFER_SET_SELECTED_OUTLETS,
  INVENTORY_TRANSFER_TRANSFERS_REQUEST,
  INVENTORY_TRANSFER_SET_CURRENT_PAGE,
  INVENTORY_TRANSFER_SET_TOTAL_PAGE,
  INVENTORY_TRANSFER_ON_CLICK_ROW,
  INVENTORY_TRANSFER_OPEN_RIGHT_COLUMN,
  INVENTORY_TRANSFER_CLOSE_RIGHT_COLUMN,
  INVENTORY_TRANSFER_ON_CHANGE_OUTLET_IDS,
  INVENTORY_TRANSFER_ON_CHANGE_DATE,
  INVENTORY_TRANSFER_ON_CLICK_CREATE_TRANSFER,
  INVENTORY_TRANSFER_ON_CLICK_ADD_ITEM,
  INVENTORY_TRANSFER_ON_MODAL_CLICK_CANCEL,
  INVENTORY_TRANSFER_GET_ITEMS,
  INVENTORY_TRANSFER_SET_ADD_ITEMS,
  INVENTORY_TRANSFER_RESET_ADD_ITEMS,
  INVENTORY_TRANSFER_SET_ITEMS_OPTION_IS_LOADING,
  INVENTORY_TRANSFER_ON_MODAL_SELECT_CHANGE,
  INVENTORY_TRANSFER_ON_MODAL_ADD_ITEM,
  INVENTORY_TRANSFER_CLOSE_ADD_ITEM_MODAL,
  INVENTORY_TRANSFER_RESET_TRANSFERS_FORM,
  INVENTORY_TRANSFER_SET_SHOW_CONFRIM_SUBMIT_MODAL,
  INVENTORY_TRANSFER_ON_SUBMIT_CREATE_TRANSFER_FORM,
  INVENTORY_TRANSFER_ON_CONFIRM_CREATE_TRANSFER,
  INVENTORY_TRANSFER_ON_CONFIRM_ADVANCED_CREATE_TRANSFER,
  INVENTORY_TRANSFER_EXPORT,
  INVENTORY_TRANSFER_SET_IS_ITEM_ALREADY_ADDED,
  INVENTORY_TRANSFER_ON_NAMESPACE_CHANGE,
  INVENTORY_TRANSFER_SET_EXPORT_BUTTON_STATUS,
  INVENTORY_TRANSFER_SET_CONFIRM_CREATE_BUTTON_STATUS,
  INVENTORY_TRANSFER_SET_SEARCH_ITEMS_INIT,
  INVENTORY_TRANSFER_EXPORT_START,
  INVENTORY_TRANSFER_EXPORT_DONE,
  INVENTORY_TRANSFER_EXPORT_FAILED,
  INVENTORY_TRANSFER_SET_ASYNCJOBID,
  INVENTORY_TRANSFER_SET_TRANSFER_TYPE,
  INVENTORY_TRANSFER_SET_TRANSFER_ACTIVITIES,
  ADVANCE_INVENTORY_TRANSFER_SUBMIT_APPROVAL_FORM,
  INVENTORY_TRANSFER_SET_VALID_OUTLETS,
} from './constants';

import type { TAB_TYPE } from '../../../types/actionBars';

export function resetState() {
  return { type: INVENTORY_TRANSFER_RESET_STATE };
}

export function pageRequest() {
  return { type: INVENTORY_TRANSFER_PAGE_REQUEST, payload: {} };
}

export function setTransfers(transfers) {
  return { type: INVENTORY_TRANSFER_SET_TRANSFERS, payload: { transfers } };
}

export function setTransferDetail(transfer) {
  return {
    type: INVENTORY_TRANSFER_SET_TRANSFER_DETAIL,
    payload: { transfer },
  };
}

export function setTransferWithActivities(transfer) {
  return {
    type: INVENTORY_TRANSFER_SET_TRANSFER_ACTIVITIES,
    payload: transfer,
  };
}

export function setOutlets(outlets) {
  return { type: INVENTORY_TRANSFER_SET_OUTLETS, payload: { outlets } };
}

/**
 * All outlets that one business is have.
 * Not just assigned outlets bind to specific employee roles
 */
export function setAllOutlets(outlets) {
  return { type: INVENTORY_TRANSFER_SET_ALL_OUTLETS, payload: { outlets } };
}

export function setValidOutlets(outlets) {
  return { type: INVENTORY_TRANSFER_SET_VALID_OUTLETS, payload: { outlets } };
}

export function setSelectedOutletFromName(outletName: string) {
  return {
    type: INVENTORY_TRANSFER_SET_SELECTED_OUTLET_FROM_NAME,
    payload: { outletName },
  };
}

export function setSelectedOutlets(selectedOutlets) {
  return {
    type: INVENTORY_TRANSFER_SET_SELECTED_OUTLETS,
    payload: { selectedOutlets },
  };
}

export function transfersRequest(params, previousTransfers, namespace) {
  return {
    type: INVENTORY_TRANSFER_TRANSFERS_REQUEST,
    payload: { params, previousTransfers, namespace },
  };
}

export function setCurrentPage(currentPage) {
  return {
    type: INVENTORY_TRANSFER_SET_CURRENT_PAGE,
    payload: { currentPage },
  };
}

export function setTotalPage(totalPage) {
  return { type: INVENTORY_TRANSFER_SET_TOTAL_PAGE, payload: { totalPage } };
}

export function onClickRow(transfer, namespace) {
  return {
    type: INVENTORY_TRANSFER_ON_CLICK_ROW,
    payload: { transfer, namespace },
  };
}

export function openRightColumn() {
  return { type: INVENTORY_TRANSFER_OPEN_RIGHT_COLUMN };
}

export function closeRightColumn() {
  return { type: INVENTORY_TRANSFER_CLOSE_RIGHT_COLUMN };
}

export function onChangeOutletIds(outletIds, startDate, endDate, namespace) {
  return {
    type: INVENTORY_TRANSFER_ON_CHANGE_OUTLET_IDS,
    payload: { outletIds, startDate, endDate, namespace },
  };
}

export function onChangeDate(
  startDate,
  endDate,
  namespace,
  tabType?: TAB_TYPE,
  keyword?: string
) {
  return {
    type: INVENTORY_TRANSFER_ON_CHANGE_DATE,
    payload: { startDate, endDate, namespace, tabType, keyword },
  };
}

export function onClickCreateTransfer(
  outletIds,
  allOutletsIds,
  isAdvancedTransfer
) {
  return {
    type: INVENTORY_TRANSFER_ON_CLICK_CREATE_TRANSFER,
    payload: { outletIds, allOutletsIds, isAdvancedTransfer },
  };
}

export function onClickAddItem() {
  return { type: INVENTORY_TRANSFER_ON_CLICK_ADD_ITEM };
}

export function onModalClickCancel() {
  return { type: INVENTORY_TRANSFER_ON_MODAL_CLICK_CANCEL };
}

export function getItems({
  outletId,
  keyword,
  page,
  namespace,
  isInit,
  isGetFromInit,
  previousAddItems,
  previousTotalPage,
  initData,
}) {
  return {
    type: INVENTORY_TRANSFER_GET_ITEMS,
    payload: {
      outletId,
      keyword,
      page,
      namespace,
      isInit,
      isGetFromInit,
      previousAddItems,
      previousTotalPage,
      initData,
    },
  };
}

export function setAddItems(addItems) {
  return { type: INVENTORY_TRANSFER_SET_ADD_ITEMS, payload: { addItems } };
}

export function resetAddItems() {
  return { type: INVENTORY_TRANSFER_RESET_ADD_ITEMS };
}

export function setItemsOptionIsLoading(itemOptionIsLoading) {
  return {
    type: INVENTORY_TRANSFER_SET_ITEMS_OPTION_IS_LOADING,
    payload: { itemOptionIsLoading },
  };
}

export function onModalSelectChange(
  selectedItemId,
  items,
  transfers,
  namespace
) {
  return {
    type: INVENTORY_TRANSFER_ON_MODAL_SELECT_CHANGE,
    payload: { selectedItemId, items, transfers, namespace },
  };
}

export function onModalAddItems(items) {
  return { type: INVENTORY_TRANSFER_ON_MODAL_ADD_ITEM, payload: { items } };
}

export function closeAddItemModal() {
  return { type: INVENTORY_TRANSFER_CLOSE_ADD_ITEM_MODAL };
}

export function resetTransfersForm() {
  return { type: INVENTORY_TRANSFER_RESET_TRANSFERS_FORM };
}

export function setShowConfirmSubmitModal(isShowConfirmSubmitModal) {
  return {
    type: INVENTORY_TRANSFER_SET_SHOW_CONFRIM_SUBMIT_MODAL,
    payload: { isShowConfirmSubmitModal },
  };
}

export function onSubmitCreateTransfer(values) {
  return {
    type: INVENTORY_TRANSFER_ON_SUBMIT_CREATE_TRANSFER_FORM,
    payload: { values },
  };
}

export function onConfirmCreateTransfer(values, date, namespace) {
  return {
    type: INVENTORY_TRANSFER_ON_CONFIRM_CREATE_TRANSFER,
    payload: { values, date, namespace },
  };
}

// Advanced Inventory
export function onConfirmAdvancedCreateTransfer(values, date, namespace) {
  return {
    type: INVENTORY_TRANSFER_ON_CONFIRM_ADVANCED_CREATE_TRANSFER,
    payload: { values, date, namespace },
  };
}

export function exportTransfer(date, filename, outletId, namespace) {
  return {
    type: INVENTORY_TRANSFER_EXPORT,
    payload: { date, filename, outletId, namespace },
  };
}

export function setIsItemAlreadyAdded(isItemAlreadyAdded) {
  return {
    type: INVENTORY_TRANSFER_SET_IS_ITEM_ALREADY_ADDED,
    payload: { isItemAlreadyAdded },
  };
}

export function onNamespaceChange(namespace) {
  return {
    type: INVENTORY_TRANSFER_ON_NAMESPACE_CHANGE,
    payload: { namespace },
  };
}

export function setExportButtonStatus(exportButtonStatus) {
  return {
    type: INVENTORY_TRANSFER_SET_EXPORT_BUTTON_STATUS,
    payload: { exportButtonStatus },
  };
}

export function setConfirmCreateButtonStatus(isClicked) {
  return {
    type: INVENTORY_TRANSFER_SET_CONFIRM_CREATE_BUTTON_STATUS,
    payload: { isClicked },
  };
}

export function setSearchItemsInit(itemInit) {
  return {
    type: INVENTORY_TRANSFER_SET_SEARCH_ITEMS_INIT,
    payload: { itemInit },
  };
}

export function startExportTransfer() {
  return { type: INVENTORY_TRANSFER_EXPORT_START, payload: {} };
}

export function doneExportTransfer() {
  return { type: INVENTORY_TRANSFER_EXPORT_DONE, payload: {} };
}

export function errorExportTransfer() {
  return { type: INVENTORY_TRANSFER_EXPORT_FAILED, payload: {} };
}

export function setIdAsyncJob(idAsyncJob) {
  return { type: INVENTORY_TRANSFER_SET_ASYNCJOBID, payload: { idAsyncJob } };
}

// Advanced Inventory
export function setTransferType(type) {
  return {
    type: INVENTORY_TRANSFER_SET_TRANSFER_TYPE,
    payload: { type },
  };
}

export function submitApprovalForm(namespace, id, params) {
  return {
    type: ADVANCE_INVENTORY_TRANSFER_SUBMIT_APPROVAL_FORM,
    payload: { namespace, id, params },
  };
}
